var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 323.141 322.95",
    enableBackground: "new 0 0 323.141 322.95",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#F0AD00",
    points: "161.649,152.782 231.514,82.916 91.783,82.916"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7FD13B",
    points: "8.867,0 79.241,70.375 232.213,70.375 161.838,0"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#7FD13B",
    x: 192.99,
    y: 107.392,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 186.4727 -127.2386)",
    width: 107.676,
    height: 108.167
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#60B5CC",
    points: "323.298,143.724 323.298,0 179.573,0"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#5A6378",
    points: "152.781,161.649 0,8.868 0,314.432"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F0AD00",
    points: "255.522,246.655 323.298,314.432 323.298,178.879"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#60B5CC",
    points: "161.649,170.517 8.869,323.298 314.43,323.298"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElm);
export default __webpack_public_path__ + "static/media/elm.2d361ac2.svg";
export { ForwardRef as ReactComponent };